import * as React from 'react';

type BetaTagProps = React.HTMLAttributes<HTMLDivElement> & {
  text?: string;
};

export const BetaBadge: React.FC<BetaTagProps> = ({ text, style, ...props }) => {
  return (
    <div
      style={{
        backgroundColor: '#E8F1FD',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 600,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        color: '#1A73E8',
        display: 'inline-flex',
        ...style,
      }}
      role="status"
      aria-label="Beta version indicator"
      {...props}
    >
      {text || 'beta'}
    </div>
  );
};
